import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomProductIntroComponent } from './custom-product-intro/custom-product-intro.component'
import { CustomProductSummaryComponent } from './custom-product-summary/custom-product-summary.component'
import {
  StarRatingModule,
  IconModule,
  SpinnerModule,
  MediaModule,
  DIALOG_TYPE,
  TabParagraphContainerModule,
  ItemCounterModule,
} from '@spartacus/storefront'
import {
  ConfigModule,
  CmsConfig,
  I18nModule,
  provideConfig,
} from '@spartacus/core'
import { CustomProductRoutesModule } from '../config/product-routes.module'
import { AddToCartModule } from '../cart/add-to-cart/add-to-cart.module'
import { BomListComponent } from './bom-list/bom-list.component'
import { BomProductComponent } from './bom-product/bom-product.component'
// import { TabParagraphContainerModule } from './tab-paragraph-container/tab-paragraph-container.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { NgSelectModule } from '@ng-select/ng-select'
import { MyFavouriteDialogComponent } from './my-favourite-dialog/my-favourite-dialog.component'
import { ClickOutsideModule } from '../../shared/directive/clickOutside/click-outside.module'
// import { ItemCounterModule } from '../../shared/directive/item-counter/item-counter.module'
import { environment } from '../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../config/dialog.config'

@NgModule({
  declarations: [
    CustomProductIntroComponent,
    CustomProductSummaryComponent,
    BomListComponent,
    BomProductComponent,
    MyFavouriteDialogComponent,
  ],
  imports: [
    CommonModule,
    StarRatingModule,
    IconModule,
    CustomProductRoutesModule,
    AddToCartModule,
    TabParagraphContainerModule,
    FormsModule,
    ReactiveFormsModule,
    ClickOutsideModule,
    RouterModule,
    MatTooltipModule,
    SpinnerModule,
    MediaModule,
    MatCheckboxModule,
    ItemCounterModule,
    I18nModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['pdp'],
        },
      },
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomProductIntroComponent,
        },
        ProductSummaryComponent: {
          component: CustomProductSummaryComponent,
        },
        VSBOMProductDisplayComponent: {
          component: BomListComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.MY_FAVOURITES_PDP]: {
          inlineRoot: true,
          component: MyFavouriteDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class PdpModule {}
